import { render, staticRenderFns } from "./WatchPredicts.vue?vue&type=template&id=f18b1c20&scoped=true"
import script from "./WatchPredicts.vue?vue&type=script&lang=js"
export * from "./WatchPredicts.vue?vue&type=script&lang=js"
import style0 from "./WatchPredicts.vue?vue&type=style&index=0&id=f18b1c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18b1c20",
  null
  
)

export default component.exports